// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__poPT-","option":"SuperSelect_option__PKijO"};